/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Positions_RetryInputs */

const vi_report_inventory_positions_retry = /** @type {(inputs: Report_Inventory_Positions_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

/**

* @param {Report_Inventory_Positions_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_positions_retry = /** @type {((inputs?: Report_Inventory_Positions_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Positions_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_positions_retry(inputs)
});